import { render, staticRenderFns } from "./BalanceWidget.vue?vue&type=template&id=6c34d939&scoped=true"
import script from "./BalanceWidget.vue?vue&type=script&lang=js"
export * from "./BalanceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34d939",
  null
  
)

export default component.exports